import { getPartnerByDomain } from '../../../../utils';

export const PRODUCTION_API_URL = 'https://fotoscapes.com';
export const SANDBOX_API_URL = 'https://staging.fotoscapes.com';
export const PRODUCTION_LOCATION_API_URL =
  'https://location-api.mobileposse.com';
export const SANDBOX_LOCATION_API_URL =
  'https://location-api.sandbox.mobileposse.com';
export const ORIGIN_SANDBOX_API_URL = 'https://origin.staging.fotoscapes.com';
export const PRODUCTION_DEFAULT_CKEY = 'fb529d256155b9c6';
export const SANDBOX_DEFAULT_CKEY = 'fb529d256155b9c6';

export const getPartner = (partnerOverride: string | null): string => {
  // client
  const partner =
    window && window.__RUNTIME_CONFIG__
      ? (window as any).__RUNTIME_CONFIG__.partner
      : undefined;
  if (partner) {
    return partner;
  }

  if (partnerOverride) {
    return partnerOverride;
  }

  const host = window?.location?.hostname || '';
  return getPartnerByDomain(host);
};

export const getDefaultAPIKey = () => {
  // Check if running in a browser environment
  const isBrowser = typeof window !== 'undefined' && window.document;

  // Client-side: Try __RUNTIME_CONFIG__
  if (
    isBrowser &&
    window.__RUNTIME_CONFIG__ &&
    (window as any).__RUNTIME_CONFIG__.DEFAULT_CKEY
  ) {
    return (window as any).__RUNTIME_CONFIG__.DEFAULT_CKEY;
  }

  // Server-side or if client-side config is missing: Try process.env
  if (typeof process !== 'undefined' && process?.env?.DEFAULT_CKEY) {
    return process.env.DEFAULT_CKEY;
  }

  // Client-side fallback based on hostname
  if (isBrowser) {
    const host = window.location.hostname;
    if (
      host.includes('staging.fotoscapes.com') ||
      host.includes('staging.get-moment.com') ||
      host.startsWith('fotoscapes-') ||
      host.startsWith('localhost')
    ) {
      return SANDBOX_DEFAULT_CKEY;
    }
    if (host === 'fotoscapes.com' || host.includes('get-moment.com')) {
      return PRODUCTION_DEFAULT_CKEY;
    }
  }

  return PRODUCTION_DEFAULT_CKEY;
};

// /src/pages/Root/services/api/api-utils.ts
export const getBaseUrl = () => {
  // Check if running in a browser environment
  const isBrowser = typeof window !== 'undefined' && window.document;

  // Client-side: Try __RUNTIME_CONFIG__
  if (
    isBrowser &&
    window.__RUNTIME_CONFIG__ &&
    (window as any).__RUNTIME_CONFIG__.API_BASE_URL
  ) {
    return (window as any).__RUNTIME_CONFIG__.API_BASE_URL;
  }

  // Server-side or if client-side config is missing: Try process.env
  if (typeof process !== 'undefined' && process?.env?.API_BASE_URL) {
    return process.env.API_BASE_URL;
  }

  // Client-side fallback based on hostname
  if (isBrowser) {
    const host = window.location.hostname;
    if (
      host.includes('staging.fotoscapes.com') ||
      host.includes('staging.get-moment.com') ||
      host.startsWith('fotoscapes-') ||
      host.startsWith('localhost')
    ) {
      return SANDBOX_API_URL;
    }
    if (host === 'fotoscapes.com' || host.includes('get-moment.com')) {
      return PRODUCTION_DEFAULT_CKEY;
    }
  }

  // Default fallback (could be production or a specific server default if not in browser)
  return PRODUCTION_API_URL;
};

export const getLocationApiBaseUrl = () => {
  // Check if running in a browser environment
  const isBrowser = typeof window !== 'undefined' && window.document;

  // Client-side: Try __RUNTIME_CONFIG__
  if (
    isBrowser &&
    window.__RUNTIME_CONFIG__ &&
    (window as any).__RUNTIME_CONFIG__.LOCATION_API_BASE_URL
  ) {
    return (window as any).__RUNTIME_CONFIG__.LOCATION_API_BASE_URL;
  }

  // Server-side or if client-side config is missing: Try process.env
  if (typeof process !== 'undefined' && process?.env?.LOCATION_API_BASE_URL) {
    return process.env.LOCATION_API_BASE_URL;
  }

  // Client-side fallback based on hostname
  if (isBrowser) {
    const host = window.location.hostname;
    if (
      host.includes('staging.fotoscapes.com') ||
      host.includes('staging.get-moment.com') ||
      host.startsWith('fotoscapes-') ||
      host.startsWith('localhost')
    ) {
      return SANDBOX_LOCATION_API_URL;
    }
    if (host === 'fotoscapes.com' || host.includes('get-moment.com')) {
      return PRODUCTION_LOCATION_API_URL;
    }
  }

  // Default fallback (could be production or a specific server default if not in browser)
  return PRODUCTION_LOCATION_API_URL;
};

export const getFullURL = (response: any) => {
  let url = response.config.baseURL || '';

  if (response?.config?.url) {
    url += response?.config?.url?.startsWith('/')
      ? response?.config?.url
      : `/${response?.config?.url}`;
  }

  return url;
};

export const getApiMetrics = (response: any, requestTime: number) => {
  const responseTime = new Date().getTime() - requestTime;

  return {
    responseTime: responseTime,
    url: getFullURL(response),
    responseCode: `${response.status}`,
  };
};
